import { render, staticRenderFns } from "./PickupStatusChip.vue?vue&type=template&id=5ec1cc4b&"
import script from "./PickupStatusChip.vue?vue&type=script&lang=ts&"
export * from "./PickupStatusChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
